import React from "react";
import MapHierarchy from "src/pages/StrategicPlanning/MapHierarchy";
import Maps from "src/pages/StrategicPlanning/Maps";
import MapsPrint from "src/pages/StrategicPlanning/Maps/Print";
import Okr from "src/pages/StrategicPlanning/Okr";
import strategiesPanel from "src/pages/StrategicPlanning/Strategies";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/okr/panel" key="okr" exact component={Okr} isPrivate/>,
	<RoutePrivate path="/okr/panel/:okrId" permissionPath="/okr/panel" key="okrId" exact component={Okr} isPrivate/>,
	<RoutePrivate path="/maps/hierarchy" key="hierarchymaps" exact component={MapHierarchy} isPrivate/>,
	<RoutePrivate path="/maps/panel" key="maps" exact component={Maps} isPrivate/>,
	<RoutePrivate path="/maps/panel/:mapId" permissionPath="/maps/panel" key="mapsId" exact component={Maps} isPrivate/>,
	<RoutePrivate path="/maps/print/:mapId" permissionPath="/maps/panel" key="mapsPrint" exact component={MapsPrint} isPrivate/>,
	<RoutePrivate path="/strategies/panel"  key="strategiesPanel" exact component={strategiesPanel} isPrivate/>
];
